const swrConfig={
    refreshInterval:0,
    revalidate:false,
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: true

}

export default {swrConfig};